import { useState } from 'react';
import { gridSpacing } from 'app/constant';
import {
    Button,
    Modal,
    Box,
    Typography,
    Grid,
    TextField,
    TableContainer,
    Paper,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TablePagination,
    Checkbox
} from '@mui/material';
import { deepPurple } from '@mui/material/colors';
import FilterTasklist from './FilterTasklist';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const taskListColumns = [
    { id: 'id', label: 'ID', minWidth: 30 },
    { id: 'name', label: 'Task Name', minWidth: 120 },
    { id: 'taskValue', label: 'Task Value', minWidth: 120 },
    { id: 'code', label: 'Task Code', minWidth: 120 }
];

const TasklistModal = ({
    comboModalIsOpen,
    handleComboModalClose,
    selectedComboTaskIDs,
    setSelectedComboTaskIDs,
    tasklistFilterIsLoading,
    setTasklistFilterIsLoading,
    tasklist,
    fetchTaskList
}) => {
    const [tasklistPage, setTasklistPage] = useState(0);
    const [rowsPerTasklistPage, setRowsPerTasklistPage] = useState(100);

    const handleChangeTasklistPage = (event, newPage) => {
        setTasklistPage(newPage);
    };

    const handleChangeRowsPerTasklistPage = (event) => {
        setRowsPerTasklistPage(+event.target.value);
        setTasklistPage(0);
    };

    const handleTaskListRowClick = (rowId) => {
        const isSelected = selectedComboTaskIDs.includes(rowId);
        if (isSelected) {
            setSelectedComboTaskIDs((prevSelected) => prevSelected.filter((taskId) => taskId !== rowId));
        } else {
            setSelectedComboTaskIDs((prevSelected) => [...prevSelected, rowId]);
        }
    };

    return (
        <Modal
            open={comboModalIsOpen}
            onClose={handleComboModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <FilterTasklist
                    fetchTaskList={fetchTaskList}
                    setTasklistFilterIsLoading={setTasklistFilterIsLoading}
                    tasklistFilterIsLoading={tasklistFilterIsLoading}
                />
                <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
                    <TableContainer stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                {taskListColumns.map((c) => {
                                    return (
                                        <TableCell key={c.id} align="left" style={{ minWidth: c.minWidth }}>
                                            {c.label}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tasklist
                                .slice(tasklistPage * rowsPerTasklistPage, tasklistPage * rowsPerTasklistPage + rowsPerTasklistPage)
                                .map((row) => {
                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={row.id}
                                            onClick={() => handleTaskListRowClick(row.id)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <TableCell>
                                                <Checkbox
                                                    checked={selectedComboTaskIDs.includes(row.id)}
                                                    onChange={(event) => event.stopPropagation()}
                                                />
                                            </TableCell>
                                            <TableCell>{row.id}</TableCell>
                                            <TableCell>{row.name}</TableCell>
                                            <TableCell>{row.taskValue}</TableCell>
                                            <TableCell>{row.code}</TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </TableContainer>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={tasklist.length}
                    rowsPerPage={rowsPerTasklistPage}
                    page={tasklistPage}
                    onPageChange={handleChangeTasklistPage}
                    onRowsPerPageChange={handleChangeRowsPerTasklistPage}
                />
            </Box>
        </Modal>
    );
};

export default TasklistModal;
